export default "__VITE_ASSET__B$k_XZvc__"